//import { AxiosWrapper, Logger } from "fe_comp_base";
import AxiosWrapper from "../../../basecomp/base/AxiosWrapper";
import Logger from "../../../basecomp/base/Logger";
import axios from "axios";

const {
  axiosPostCallWithToken,
  axiosGetCallWithToken,
  axiosPutCallWithToken,
  axiosGetCallHeaderWithToken,
} = AxiosWrapper;

export const uploadMaterialData = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
   // single file directly
  const response = await axiosPostCallWithToken(
    `/mct/uploadMaterialData`,
    formData
  );
  return response;
};

export const uploadBulkEmailRequests = async (file) => {
  const formData = new FormData();
  formData.append("file", file); // single File, no loop
  const response = await axiosPostCallWithToken(
    `/mct/uploadBulkEmailRequests`,
    formData
  );
  return response;
};

export const addEmailRequest = async (emailInput) => {
  const response = await axiosPostCallWithToken(
    `/mct/addEmailRequest`,
    emailInput
  );
  return response;
};

export const getDownloadExportFile = async () => {
  const response = await axiosGetCallHeaderWithToken(
    `/mct/downloadExportFile?tableName="mct_table"`,
    "application/excel"
  );
  return response;
};

export const getMCTTable = async () => {
  const response = await axiosGetCallWithToken(`/mct/getMCTTable`);
  return response;
};

export const downloadExcelByDateRange = async (
  startDate,
  endDate,
  buttonKey
) => {
  const response = await axiosGetCallHeaderWithToken(
    `/mct/downloadExcelByDateRange?startDate=${startDate}&endDate=${endDate}&method=${buttonKey}`,
    "application/excel"
  );
  return response;
};

export const updateStatusMCTTableById = async (id, action = "start") => {
  const response = await axiosPutCallWithToken(
    `/mct/updateStatusMCTTableById`,
    { id: id ,
      action: action 
    }
  );
  return response;
};

export const updateStatusAndData = async (
  id,
  processInput,
  newStatus,
  userName
) => {
  const response = await axiosPutCallWithToken(`/mct/updateStatusAndData`, {
    id: id,
    input: processInput,
    newStatus: newStatus,
    userName: userName,
  });
  return response;
};

export const validateData = async (id, processInput, type) => {
  const response = await axiosPostCallWithToken(`/mct/validateData`, {
    inputJson: processInput,
  });
  return response;
};

export const getSampleUploadFile = async (type) => {
  const response = await axiosGetCallHeaderWithToken(
    `/mct/getSampleCsv?type=${type}`,
    "text/csv"
  );
  return response;
};
export const searchMaterials = async (query) => {
  const response = await axiosGetCallWithToken(
    `/mct/materials/search?q=${encodeURIComponent(query)}`,
  );
  return response;
};